var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "none", viewBox: "0 0 14 14" }, props),
    React.createElement("path", { fill: "#3AAE97", fillRule: "evenodd", stroke: "#3AAE97", d: "M6.78 12.83c.2.22.54.23.75.01l5.31-5.44c.1-.1.16-.25.16-.4 0-.15-.06-.3-.16-.4l-5.3-5.44a.52.52 0 0 0-.76 0c-.21.23-.2.58 0 .8l4.38 4.49H1.54c-.3 0-.54.24-.54.55 0 .3.24.55.54.55h9.61l-4.37 4.5a.57.57 0 0 0 0 .79z", clipRule: "evenodd" })
  );
});